import { ActionTypes } from '.';
import { ConsolidationKeyInterface } from '../reducers/consolidate';

export enum ConsolidationStatus {
  VERIFYING,
  ALREADY_DEPOSITED,
  READY_FOR_DEPOSIT,
}

export interface UpdateValidatorsAction {
  type: ActionTypes.updateValidators;
  payload: ConsolidationKeyInterface[];
}

export interface UpdateSourceValidatorAction {
  type: ActionTypes.updateSourceValidator;
  payload: string; // pubkey
}

export interface UpdateTargetValidatorAction {
  type: ActionTypes.updateTargetValidator;
  payload: string; // pubkey
}

export interface UpdateConsolidationStatusAction {
  type: ActionTypes.updateConsolidationStatus;
  payload: {
    pubkey: string;
    status: ConsolidationStatus;
  };
}
